<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import {
  useHead, useSeoMeta
} from '@unhead/vue'
import { ref, onMounted } from 'vue'
import ogImage from '@/assets/opengraph/turnKey.png'

const fontsLoaded = ref(false)

onMounted(() => {
  // Check if Adobe Fonts is loaded
  document.fonts.ready.then(() => {
    fontsLoaded.value = true;
  });
})

// Set default head content
useHead({
  title: 'turnKey Research Management',
  description: 'Comprehensive solutions for research management and collaboration',
  htmlAttrs: {
    lang: 'en'
  },
  link: [
    {
      rel: 'canonical',
      href: 'https://turnkeyresearchmanagement.au'
    }
  ],
  meta: [
    {
      property: 'og:title',
      content: 'turnKey Research Management'
    },
    {
      property: 'og:description',
      content: 'Comprehensive solutions for research management and collaboration'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:url',
      content: 'https://turnkeyresearchmanagement.au'
    },
    {
      property: 'og:image',
      content: 'https://turnkeyresearchmanagement.au' + ogImage
    },
    {
      property: 'og:image:width',
      content: '1200'
    },
    {
      property: 'og:image:height',
      content: '630'
    },
    {
      property: 'og:image:type',
      content: 'image/png'
    }
  ]  
})
/**
useSeoMeta({
  title: 'turnKey Research Management',
  description: 'Comprehensive solutions for research management and collaboration',
  ogTitle: 'turnKey Research Management',
  ogDescription: 'Comprehensive solutions for research management and collaboration',
  ogImage: {
    url: 'https://turnkeyresearchmanagement.au' + ogImage,
    width: 1200,
    height: 630,
    type: 'image/png'
  },
  twitterCard: 'summary_large_image',
  twitterImage: {
    url: 'https://turnkeyresearchmanagement.au' + ogImage,
    width: 1200,
    height: 630,
    type: 'image/png'
  },
  twitterTitle: 'turnKey Research Management',
  twitterDescription: 'Comprehensive solutions for research management and collaboration',
})
*/
</script>

<template>
  <div :class="['app', { 'fonts-loaded': fontsLoaded }]">
    <Header />

    <main class="main">
      
        <router-view></router-view>
      
    </main>

    <Footer />
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/main.scss';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Proxima Nova', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-text;
  background-color: $color-background;
  transition: opacity 0.3s ease;

  &.fonts-loaded {
    opacity: 1;
  }

  &.fonts-loading {
    opacity: 0;
  }

  main {
    flex: 1;

  }

  footer {
    margin-top: auto;
  }
}
</style>
